import { Injectable, EventEmitter, Output } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { OpenSpace } from '../entities/openSpace';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Proposal } from '../entities/proposal';
import { TokenStorageService } from './token-storage.service';
import { tap, catchError } from 'rxjs/operators';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json',  'responseType' : 'text/csv' })
};


interface Person {
  name: string,
  age: number
}
@Injectable({
  providedIn: 'root'
})
export class OpenSpaceService {

  proposalList: Proposal[];
  @Output() opensChanged: EventEmitter<boolean> = new EventEmitter();
  private baseUrl = environment.apiUrl + '/api/open/';

  constructor(private http: HttpClient, private token: TokenStorageService) { }

  getOpenSpaceProposals(openSpaceId: number): Observable<any> {
    return this.http.get(this.baseUrl + openSpaceId + '/proposals', httpOptions);
  }

  getOpenSpaceRemainingVotes(openSpaceId: number): Observable<any> {
    return this.http.get(this.baseUrl + openSpaceId + '/votes', httpOptions);
  }

  getOpenSpace(openId: number): Observable<any> {
    return this.http.get<OpenSpace[]>(this.baseUrl + `${ openId }`)
    .pipe(
      catchError(this.handleError<any>('getOpen'))
      );
  }

  addOpen(open: OpenSpace): Observable<OpenSpace> {
    return this.http.post<OpenSpace>(this.baseUrl, open).pipe(
      tap(_ => this.opensChanged.emit(true)),
      // catchError(this.handleError<any>('addOpen'))
    );
  }

  updateOpen(open: OpenSpace, openId: number): Observable<any> {
    return this.http.put<OpenSpace>(`${this.baseUrl} ${ openId }`, open , httpOptions)
      .pipe(
      // catchError(this.handleError<any>('addOpen'))
    );
  }

  getReportOpen(openId: number): Observable<any> {
    return this.http.get(environment.apiUrl + '/api/report/openspace/'+ `${ openId }`+'/reportOpen', {responseType: 'text'})
    .pipe(
      catchError(this.handleError<any>('getReportOpen'))
      );
  }

  getInactiveOpenSpaces(): Observable<any> {
    return this.http.get(this.baseUrl + 'inactive', httpOptions);
  }

  getActiveOpenSpaces(): Observable<any> {
    return this.http.get(this.baseUrl + 'active');
  }

  getCurrentOpenSpaces(): Observable<any> {
    return this.http.get(this.baseUrl + 'current');
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }

}
